import { render, staticRenderFns } from "./boot.vue?vue&type=template&id=2b871307&scoped=true&"
var script = {}
import style0 from "./boot.vue?vue&type=style&index=0&id=2b871307&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b871307",
  null
  
)

export default component.exports